module.exports = __webpack_public_path__ + "static/media/tech_fund.3d1cfc9d.svg";